/**
 *
 * TilesMatchHeight
 * invokes new matchheight to recalculate height of tiles
 *
 */
export class TilesMatchHeight {

    constructor() {
        this.$tiles = $('[data-tile]');
        this.$tileHeaders = $('[data-tile-header]');
        this.$tileContents = $('[data-tile-content]');
        this.matchHeightOptions = {
            byRow: true
        };
    }

    execute() {
        let vm = this;
        // Match Height only if at least 2 tiles exist
        if (this.$tiles.length > 1) {
            $(function () {
                vm.$tileHeaders.matchHeight(this.matchHeightOptions);
                vm.$tileContents.matchHeight(this.matchHeightOptions);
            });
        }
    }
}